define.alias("ember-math-helpers/helpers/imul", "settings/helpers/imul");